<template>
  <div class="content-body">
    <div class="top">
      <div class="left-z">
        <div>账单</div>
        <div class="status">我的余额：<span v-text="company_balance"></span>元</div>
        <div class="status">冻结金额：<span>0.00</span>元</div>
      </div>
      <div class="btn">
        <!-- <el-button type="primary" size="small">修改密码</el-button> -->
      </div>
    </div>
    <div class="body">
      <div class="condition">
        <div class="form">
          <div class="demo-input-suffix">
            日期:
            <el-date-picker v-model="form.pay_time" type="daterange" value-format="yyyy-MM-dd" style="width: 250px;" align="right" size="small" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
          <div class="demo-input-suffix">
            企业名称:
            <el-select v-model="form.adv_id" placeholder="请选择活动区域" size="small" style="width: 160px; margin-left: 10px;">
              <el-option label="不限" value=""></el-option>
              <el-option :label="company_name" value="1"></el-option>
            </el-select>
          </div>
          <div class="demo-input-suffix">
            企业账号:
            <el-select v-model="form.plan_id" size="small" style="width: 160px; margin-left: 10px;">
              <el-option label="不限" value=""></el-option>
              <el-option label="1" value="1"></el-option>
            </el-select>
          </div>
          <div class="demo-input-suffix">
            类型:
            <el-select v-model="form.type" size="small" style="width: 160px; margin-left: 10px;">
              <el-option label="不限" value=""></el-option>
              <el-option :label="item.label" :value="item.value" v-for="(item, index) in options" :key="index"></el-option>
            </el-select>
          </div>
          <el-button type="primary" @click="getData" size="small">查询</el-button>
          <el-button type="primary" @click="exportExcel" size="small">EXCEL导出</el-button>

          <div style="margin: 20px 0;"></div>
        </div>
        <div class="table">
          <el-table :data="tableData" border style="width: 1250px;" size="small" :header-cell-style="{ 'background-color': '#F4F4F4', 'font-weight': 'bold', 'color': '#333' }">
            <el-table-column width="160" label="企业账户" align="center">
              <template>
                {{ user_name }}
              </template>
            </el-table-column>
            <el-table-column label="企业名称" width="200" align="center">
              <template>
                {{ company_name }}
              </template>
            </el-table-column>
            <el-table-column prop="create_time" label="日期" width="160" align="center"></el-table-column>
            <el-table-column label="类型" width="160" align="center">
              <template slot-scope="scope">
                {{ scope.row.type === 'pay' ? '账号充值' : '消耗' }}
              </template>
            </el-table-column>
            <el-table-column prop="money" label="金额(元)" width="120" align="center"></el-table-column>
            <el-table-column prop="order_no" label="交易号" width="199" align="center"></el-table-column>
            <el-table-column label="备注" width="250" align="center">
              <template slot-scope="scope">
                {{ scope.row.remark !== "0" ? scope.row.remark : '' }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="page-c">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10, 20, 30, 40, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageTotal">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  /* global require */
  name: 'bill',
  data() {
    return {
      form: {
        status: '',
        type: '',
        plan_id: '',
        adv_id: '',
        pay_time: [],
        system: '',
        value: '1'
      },
      page: 1,
      pageSize: 10,
      pageTotal: 1,
      tableData: [],
      options: [{
        value: 'pay',
        label: '账户充值'
      }, {
        value: 'log',
        label: '消费'
      }],
      // options: [{
      //   value: '1',
      //   label: '人工支付'
      // }, {
      //   value: '2',
      //   label: '支付宝支付'
      // }, {
      //   value: '3',
      //   label: '转账(转出)'
      // }, {
      //   value: '4',
      //   label: '转账(转入)'
      // }, {
      //   value: '5',
      //   label: '消费'
      // }],
      user_name: '',
      company_name: '',
      company_balance: '0.00'
    };
  },
  mounted() {
    this.setTimeInit();
    this.getData();
  },
  methods: {
    getData() {
      this.form = Object.assign({}, this.form, { page: this.page, pageSize: this.pageSize });
      this.$http.post('/trader/index/getBillLists', this.form).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
          this.pageTotal = res.count;
          this.$function.hiddenLoading();
          this.user_name = sessionStorage.getItem('user_info') ? JSON.parse(sessionStorage.getItem('user_info'))['user_name'] : '';
          this.company_balance = sessionStorage.getItem('user_info') ? JSON.parse(sessionStorage.getItem('user_info'))['company_balance'] : '0.00';
          this.company_name = sessionStorage.getItem('user_info') ? JSON.parse(sessionStorage.getItem('user_info'))['company_name'] : '';
        }
      });
    },
    exportExcel() {
      const { export_json_to_excel } = require('@/plugin/Export2Excel');
      this.$http.post('/trader/index/getExcelBillLists', this.form).then(res => {
        if (res.code === 200) {
          const tHeader = ['企业账户', '企业名称', '日期', '类型', '金额(元)', '交易号', '备注'];
          const filterVal = ['user_name', 'company_name', 'create_time', 'type', 'money', 'order_no', 'remark'];
          const result = [];
          if (res.data.length) {
            for (let i = 0; i < res.data.length; i++) {
              result.push(Object.assign({}, res.data[i], { user_name: this.user_name, company_name: this.company_name, type: res.data[i].type === 'log' ? '消耗' : '账号充值' }));
            }
          }
          const data = this.formatJson(filterVal, result);
          export_json_to_excel(tHeader, data, '账单数据');
        }
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    setTimeInit() {
      const day1 = new Date();
      day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000 * 2);
      const preToday = day1.getFullYear() + '-' + ((day1.getMonth() + 1) < 10 ? '0' + (day1.getMonth() + 1) : (day1.getMonth() + 1)) + '-' + (day1.getDate() < 10 ? '0' + day1.getDate() : day1.getDate());
      const day2 = new Date();
      day2.setTime(day2.getTime());
      const today = day2.getFullYear() + '-' + ((day2.getMonth() + 1) < 10 ? '0' + (day2.getMonth() + 1) : (day2.getMonth() + 1)) + '-' + (day2.getDate() < 10 ? '0' + day2.getDate() : day2.getDate());
      this.form.pay_time = [preToday, today];
    },
    handleSizeChange(value) {
      this.page = 1;
      this.pageSize = value;
      this.getData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.getData();
    }
  },
  watch: {

  }
};
</script>

<style lang="less" scoped>
  .top {
    height: 54px;
    background-color: #f9f9f9;
    margin-bottom: 31px;
    font-size: 16px;
    font-weight: 700;
    color: #333;
    padding-left: 22px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left-z {
      display: flex;
    }
    .status {
      font-size: 14px;
      color: #999;
      font-weight: 400;
      margin-left: 30px;
      span {
        color: #0782c3;
      }
    }
    .btn {
      float: right;
      margin-right: 40px;
    }
  }

  .body {
    padding: 0px 44px;
  }

  .condition {
    margin-top: 20px;
    width: 1250px;
    height: 55px;
    .form {
      float: left;
      width: 1250px;
    }
    .other {
      float: right;
      width: 440px;
    }
    .demo-input-suffix {
      display: inline-block;
      font-size: 14px;
      color: #999;
      margin-right: 31px;
    }
  }
  .page-c {
    margin-top: 20px;
    text-align: right;
  }

</style>
